// extracted by mini-css-extract-plugin
export var circle = "FeaturedIcons-module--circle--facba";
export var content = "FeaturedIcons-module--content--12b37";
export var item = "FeaturedIcons-module--item--e5981";
export var list = "FeaturedIcons-module--list--448fd";